<div
  *ngIf="isLoading"
  class="row center">
  <div class="col">
    <app-loading-icon
      class="u-color--light"
      size="2x"></app-loading-icon>
  </div>
</div>
<div
  *ngIf="contract"
  id="general-details"
  class="col">
  <div
    id="tool-other-info"
    class="bg-white u-shadow">
    <div class="o-tech-table__header">
      {{ "contract.datailstitle" | translate }}
    </div>
    <div class="o-tech-table__container">
      <table class="o-tech-table">
        <tbody>
          <tr
            *ngIf="!userVisible"
            class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.worktype" | translate }}
            </td>
            <td class="o-tech-table__description">{{ contract.workType }}</td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.actualservice" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ contract.actualService }}
            </td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.paymentterms" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ contract.paymentTerms }}
            </td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.contract" | translate }}
            </td>
            <td class="o-tech-table__description">{{ contract.name }}</td>
          </tr>
          <tr
            *ngIf="!userVisible"
            class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.contractitem" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ contract.contractItem }}
            </td>
          </tr>
          <tr
            *ngIf="!userVisible"
            class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.amount" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ contract.amount === 0 ? "" : contract.amount }}
            </td>
          </tr>
          <tr
            *ngIf="!userVisible"
            class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.berpercentage" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ contract.berPercentage === 0 ? "" : contract.berPercentage }}
            </td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.productsold" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ contract.productSold }}
            </td>
          </tr>
          <tr
            *ngIf="!userVisible"
            class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.mandays" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ contract.contractManDays === 0 ? "" : contract.contractManDays }}
            </td>
          </tr>
          <tr
            *ngIf="!userVisible"
            class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.pricelist" | translate }}
            </td>
            <td class="o-tech-table__description">{{ contract.priceList }}</td>
          </tr>
          <tr
            *ngIf="!userVisible"
            class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.reverseber" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ (contract.isReverseBer ? "label.yes" : "label.no") | translate }}
            </td>
          </tr>
          <tr
            *ngIf="!userVisible"
            class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.default" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ (contract.isDefault ? "label.yes" : "label.no") | translate }}
            </td>
          </tr>
          <tr
            *ngIf="!userVisible"
            class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "contract.decrement" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ (contract.isDecrement ? "label.yes" : "label.no") | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    *ngIf="contract.comments"
    id="tool-notes"
    class="bg-white u-shadow">
    <div class="o-tech-table__header row between">
      {{ "contract.notes" | translate }}
    </div>
    <div class="o-tech-table__container">
      <table class="o-tech-table">
        <tbody>
          <tr class="o-tech-table__item">
            <td class="o-tech-table__full-width">
              <div>
                <pre>{{ contract.comments }}</pre>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
